/* Mobitopya sepet çekmecesi
   Tüm tutarlar Shopify'ın /cart.js yanıtından okunur; tema tarafında
   indirim hesabı yapılmaz. İndirimler Shopify'da otomatik indirim veya
   kupon olarak tanımlanır ve buraya hazır gelir. */
(function () {
  var drawer = document.getElementById('cartDrawer');
  var backdrop = document.getElementById('cartDrawerBackdrop');
  var closeBtn = document.getElementById('cartDrawerClose');
  if (!drawer || !backdrop) return;

  var moneyFormatter = null;

  function fmtMoney(cents, currency) {
    var amount = (cents || 0) / 100;
    if (!moneyFormatter) {
      try {
        moneyFormatter = new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: currency || 'TRY',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } catch (e) {
        moneyFormatter = null;
      }
    }
    if (moneyFormatter) return moneyFormatter.format(amount);
    return amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Shopify CDN görselini istenen genişlikte ister
  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* ── Aç / kapat ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderDrawer();
  }
  window.mobitopyaOpenCartDrawer = openDrawer;

  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  var headerCart = document.querySelector('.site-header__cart');
  if (headerCart) {
    headerCart.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  /* ── Sepete ekle formlarını yakala ──
     FormData olduğu gibi gönderilir; line item properties, selling plan gibi
     alanlar kaybolmasın. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var btn = form.querySelector('[name="add"]');
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span style="opacity:.6">Ekleniyor…</span>';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        if (btn) {
          btn.innerHTML = originalHtml;
          btn.disabled = false;
        }
        updateCartCount();
        openDrawer();
      })
      .catch(function (err) {
        if (btn) {
          btn.innerHTML = originalHtml;
          btn.disabled = false;
        }
        alert((err && err.description) || 'Ürün sepete eklenemedi, lütfen tekrar deneyin.');
      });
  });

  /* ── Çekmece içeriği ── */
  function renderDrawer() {
    var bodyEl = document.getElementById('cartDrawerBody');
    if (!bodyEl) return;
    bodyEl.innerHTML = '<div class="cart-drawer__loading">Yükleniyor…</div>';

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bodyEl.innerHTML = buildDrawerHTML(cart);
        bindDrawerEvents(bodyEl, cart);
      })
      .catch(function () {
        bodyEl.innerHTML = '<div class="cart-drawer__loading">Sepet yüklenemedi.</div>';
      });
  }

  function buildDrawerHTML(cart) {
    if (cart.item_count === 0) {
      return '<div class="cd-empty">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p>Sepetiniz boş</p>' +
        '<a href="/collections/all">Alışverişe Başla</a>' +
        '</div>';
    }

    var currency = cart.currency;

    var html = '<div class="cd-shipping-note">' +
      '<span>📦</span><span>Siparişiniz <strong>1-3 iş gününde</strong> kargoya verilir · Ücretsiz kargo</span>' +
      '</div>';

    html += '<div class="cd-items">';
    cart.items.forEach(function (item) {
      var img = sizedImage(item.image, 160);
      var title = escapeHtml(item.product_title);
      var hasLineDiscount = item.original_line_price > item.final_line_price;

      html += '<div class="cd-item" data-key="' + escapeHtml(item.key) + '">' +
        (img
          ? '<img class="cd-item__img" src="' + escapeHtml(img) + '" alt="' + title + '" loading="lazy">'
          : '<div class="cd-item__img"></div>') +
        '<div class="cd-item__info">' +
          '<span class="cd-item__name">' + title + '</span>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="cd-item__variant">' + escapeHtml(item.variant_title) + '</span>'
            : '') +
          '<div class="cd-item__prices">' +
            '<span class="cd-item__price">' + fmtMoney(item.final_line_price, currency) + '</span>' +
            (hasLineDiscount
              ? '<span class="cd-item__compare">' + fmtMoney(item.original_line_price, currency) + '</span>'
              : '') +
          '</div>' +
          '<div class="cd-item__row">' +
            '<div class="cd-qty">' +
              '<button class="cd-qty__btn" data-action="decrease" data-key="' + escapeHtml(item.key) + '">−</button>' +
              '<span class="cd-qty__val">' + item.quantity + '</span>' +
              '<button class="cd-qty__btn" data-action="increase" data-key="' + escapeHtml(item.key) + '">+</button>' +
            '</div>' +
            '<button class="cd-item__remove" data-key="' + escapeHtml(item.key) + '">Kaldır</button>' +
          '</div>' +
        '</div>' +
        '</div>';
    });
    html += '</div>';

    /* Toplamlar — hepsi Shopify'dan */
    var discountRows = '';
    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      discountRows += '<div class="cd-totals__row">' +
        '<span>' + escapeHtml(discount.title) + '</span>' +
        '<span class="cd-totals__discount">−' + fmtMoney(discount.total_allocated_amount, currency) + '</span>' +
        '</div>';
    });

    html += '<div class="cd-footer">' +
      '<div class="cd-totals">' +
        '<div class="cd-totals__row"><span>Ara Toplam</span><span>' + fmtMoney(cart.original_total_price, currency) + '</span></div>' +
        discountRows +
        '<div class="cd-totals__row"><span>Kargo</span><span class="cd-totals__free">Ücretsiz</span></div>' +
        '<div class="cd-totals__row cd-totals__row--total"><span>Toplam</span><span>' + fmtMoney(cart.total_price, currency) + '</span></div>' +
      '</div>' +
      '<button class="cd-checkout-btn" id="cdCheckoutBtn">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>' +
        'Güvenli Ödemeye Geç' +
      '</button>' +
      '<div class="cd-payment-logos">' +
        '<span>VISA</span><span>MC</span><span>Troy</span><span>iyzico</span>' +
      '</div>' +
      '</div>';

    return html;
  }

  function bindDrawerEvents(bodyEl, cart) {
    var checkoutBtn = document.getElementById('cdCheckoutBtn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        window.location.href = '/checkout';
      });
    }

    bodyEl.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.cd-qty__btn');
      var removeBtn = e.target.closest('.cd-item__remove');

      if (qtyBtn) {
        var key = qtyBtn.dataset.key;
        var action = qtyBtn.dataset.action;
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!item) return;
        var newQty = action === 'increase' ? item.quantity + 1 : Math.max(0, item.quantity - 1);
        changeQty(key, newQty);
      }

      if (removeBtn) {
        changeQty(removeBtn.dataset.key, 0);
      }
    });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderDrawer();
      });
  }

  function updateCartCount(count) {
    var cartIcon = document.querySelector('.site-header__cart');
    if (!cartIcon) return;

    function paint(value) {
      var badge = cartIcon.querySelector('.site-header__count');
      if (value > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'site-header__count';
          cartIcon.appendChild(badge);
        }
        badge.textContent = value;
      } else if (badge) {
        badge.remove();
      }
    }

    if (count === undefined) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.item_count); });
    } else {
      paint(count);
    }
  }
})();
